// Un seul client. Le jeton, la collectivité choisie et l'environnement
// voyagent dans les en-têtes : le serveur revérifie les droits à chaque appel.
const state = {
  token: localStorage.getItem('ucivis.token') || '',
  org: localStorage.getItem('ucivis.org') || '',
  env: localStorage.getItem('ucivis.env') || 'draft',
}

export const session = {
  get token() { return state.token },
  get org() { return state.org },
  get env() { return state.env },
  setToken(t) { state.token = t; localStorage.setItem('ucivis.token', t) },
  setOrg(id) { state.org = id; localStorage.setItem('ucivis.org', id) },
  setEnv(e) { state.env = e; localStorage.setItem('ucivis.env', e) },
  clear() { localStorage.clear(); state.token = ''; state.org = ''; },
}

async function req(path, { method = 'GET', body } = {}) {
  const res = await fetch(path, {
    method,
    headers: {
      'Content-Type': 'application/json',
      ...(state.token ? { Authorization: `Bearer ${state.token}` } : {}),
      ...(state.org ? { 'X-Ucivis-Org': state.org } : {}),
      'X-Ucivis-Env': state.env,
    },
    body: body ? JSON.stringify(body) : undefined,
  })
  if (res.status === 401) { session.clear(); window.location.reload() }
  if (!res.ok) {
    const d = await res.json().catch(() => ({}))
    throw new Error(typeof d.detail === 'string' ? d.detail : d.detail?.message || 'Erreur inattendue')
  }
  return res.status === 204 ? null : res.json()
}

export const api = {
  config: () => req('/api/console/config'),
  login: (email, password) => req('/api/auth/login', { method: 'POST', body: { email, password } }),
  me: () => req('/api/auth/me'),
  orgs: () => req('/api/console/orgs'),
  createOrg: (payload) => req('/api/console/orgs', { method: 'POST', body: payload }),
  shared: (orgId) => req(`/api/console/orgs/${orgId}/shared`),
  adopt: (orgId, key) => req(`/api/console/orgs/${orgId}/adopt/${key}`, { method: 'POST' }),

  requests: (status = 'open', q = '') => req(`/api/admin/requests?status=${status}&q=${encodeURIComponent(q)}`),
  request: (id) => req(`/api/admin/requests/${id}`),
  action: (id, actionId, comment = '') =>
    req(`/api/admin/requests/${id}/actions/${actionId}`, { method: 'POST', body: { comment } }),
  note: (id, text) => req(`/api/admin/requests/${id}/note`, { method: 'POST', body: { text } }),

  catalog: () => req('/api/admin/catalog'),
  install: (key) => req(`/api/admin/catalog/${key}/install`, { method: 'POST' }),
  forms: () => req('/api/admin/forms'),
  form: (key) => req(`/api/admin/forms/${key}`),
  saveForm: (key, payload) => req(`/api/admin/forms/${key}`, { method: 'PATCH', body: payload }),
  removeForm: (key) => req(`/api/admin/forms/${key}`, { method: 'DELETE' }),

  workflows: () => req('/api/admin/workflows'),
  workflow: (key) => req(`/api/admin/workflows/${key}`),
  saveWorkflow: (key, payload) => req(`/api/admin/workflows/${key}`, { method: 'PATCH', body: payload }),
  vocabulary: (key) => req(`/api/admin/workflows/${key}/vocabulary`),
  simulate: (key, payload) => req(`/api/admin/workflows/${key}/simulate`, { method: 'POST', body: payload }),

  dashboard: () => req('/api/admin/dashboard'),
  formsStatus: () => req('/api/admin/forms-status'),
  suspend: (key) => req(`/api/admin/forms/${key}/suspend`, { method: 'POST' }),
  resume: (key) => req(`/api/admin/forms/${key}/resume`, { method: 'POST' }),

  mails: () => req('/api/admin/mails'),
  saveMail: (key, payload) => req(`/api/admin/mails/${key}`, { method: 'PATCH', body: payload }),
  createMail: (payload) => req('/api/admin/mails', { method: 'POST', body: payload }),
  deleteMail: (key) => req(`/api/admin/mails/${key}`, { method: 'DELETE' }),
  mailPreview: (key) => req(`/api/admin/mails/${key}/preview`),
  mailVariables: () => req('/api/admin/mail-variables'),

  agendas: () => req('/api/admin/agendas'),
  saveAgenda: (key, payload) => req(`/api/admin/agendas/${key}`, { method: 'PATCH', body: payload }),
  createAgenda: () => req('/api/admin/agendas', { method: 'POST' }),
  bookings: () => req('/api/admin/bookings'),
  cancelBooking: (id) => req(`/api/admin/bookings/${id}`, { method: 'DELETE' }),

  outbox: () => req('/api/admin/outbox'),
  workflowTemplates: () => req('/api/admin/workflow-templates'),
  actionCatalog: () => req('/api/admin/action-catalog'),
  deleteWorkflow: (key) => req(`/api/admin/workflows/${key}`, { method: 'DELETE' }),
  createWorkflow: (payload) => req('/api/admin/workflows', { method: 'POST', body: payload }),
  org: () => req('/api/admin/org'),
  saveOrg: (payload) => req('/api/admin/org', { method: 'PATCH', body: payload }),

  site: () => req('/api/admin/site'),
  saveSite: (payload) => req('/api/admin/site', { method: 'PATCH', body: payload }),
  publishPreview: () => req('/api/admin/publish'),
  publish: () => req('/api/admin/publish', { method: 'POST' }),
}
